module.exports = {
  EnrichedPDF: {
    Allow_fullscreen: "Tam ekrana izin ver",
    Show_controls: "Kontrol butonlarını göster",
    URL: "URL",
    background_color: "Arka Plan Rengi",
    border_color: "Çerçeve Rengi",
    border_size: "Çerçeve Genişliği",
    border_style: "Çerçeve Stili",
    box_style: "Kutu Stili",

    Coords: "Koordinatlar",
    opacity: "Opaklık",
    padding: "Alan",
    empty_title: "PDF ekleyin",
    empty_hint: "Dosyalar'dan bir PDF yükleyin veya sağ paneldeki URL alanına bağlantı yapıştırın.",
    loading: "PDF yükleniyor…",
    unavailable_title: "PDF gösterici kullanılamıyor",
    unavailable_hint: "PDF kütüphanesi yüklenemedi. Lütfen sayfayı yenileyin.",
    PluginName: "PDF Gösterici",
    radius: "Radyan",
    source: "Kaynak",
    message_mark_xyp:
      "Yanlış bir değer seçtiniz. Virgülle ayrılmış üç sayı girmelisiniz. Örn. 4.56,90.76,1",
    message_mark_percentage:
      "Yanlış bir değer seçtiniz.  Yüzdelik aralık 0 ile 100 arasında olmalıdır. Örneğin 45.66%",
  },
};
